// Take unique Id of inputs and retrieves sibling components
const getComponents = id => ({
  street_number: {
    component: `${id}`,
    type: "long_name"
  },
  optional_line_2: {
    component: `${id}-line-2`,
    type: "long_name"
  },
  locality: {
    component: `${id}-city`,
    type: "long_name"
  },
  postal_code: {
    component: `${id}-postal`,
    type: "short_name"
  },
  country: {
    component: `${id}-country`,
    type: "short_name"
  },
  administrative_area_level_1: {
    component: `${id}-state`,
    type: "short_name"
  },
  route: {
    component: `${id}`,
    type: "long_name"
  }
});

$(document).ready(() => {
  const placesState = {};

  const setup = function(parent) {
    const getKey = id => {
      if (parent) return parent + " #" + id;

      return "#" + id;
    };
    const selector = parent
      ? parent + " input.places-autocomplete-line-1"
      : ".places-autocomplete-line-1";
    $(selector).each((i, e) => {
      const inputId = $(e).attr("id");
      const key = getKey(inputId);
      if (!placesState[key]) {
        placesState[key] = {
          autocomplete: null,
          components: getComponents(inputId)
        };
      }
    });

    // Listen's to focus event for auto complete
    $(selector).focus(function(e) {
      // Get the id of current focused element
      const inputId = $(e.target).attr("id");
      // Initialize autocomplete
      const key = getKey(inputId);
      // if (!placesState[key].autocomplete) {
      initAutocomplete(inputId);
      // }
    });

    function initAutocomplete(id) {
      // Create the autocomplete object, restricting the search predictions to
      // geographical location types.
      const key = getKey(id);
      placesState[key].autocomplete = new google.maps.places.Autocomplete(
        $(key)[0],
        {
          types: ["geocode"]
        }
      );

      // Avoid paying for data that you don't need by restricting the set of
      // place fields that are returned to just the address components.
      placesState[key].autocomplete.setFields(["address_components"]);

      // Get the place details from the autocomplete object.
      placesState[key].autocomplete.addListener("place_changed", () =>
        getAddress(key)
      );
    }

    // When user chooses an address then parse returned value to consumable values
    function getAddress(id) {
      try {
        const { address_components } = placesState[id].autocomplete.getPlace();
        Object.keys(placesState[id].components).forEach(component => {
          const container = `.${placesState[id].components[component].component}-container`;
          $(container).css({ display: "block" });
        });

        // Get each component of the address from the place details,
        // and then fill-in the corresponding field on the form.
        address_components.forEach(function(place) {
          const addressType = place.types[0];
          if (placesState[id].components[addressType]) {
            const val = place[placesState[id].components[addressType].type];
            const sel = `#${placesState[id].components[addressType].component}`;

            if (addressType === "country") {
              const stateCode = "administrative_area_level_1";
              const t = `#${placesState[id].components[stateCode].component}`;
              const tV = address_components.find(function(v) {
                return v.types[0] === stateCode;
              });
              $(sel)
                .val(val)
                .trigger("change");

              $(t)
                .val(tV.short_name)
                .trigger("change");
            } else if (addressType !== "route") {
              $(sel)
                .val(val)
                .trigger("change");
            } else {
              const previousValue = $(sel).val();
              $(sel)
                .val(previousValue.concat(" " + val))
                .trigger("change");
            }
          }
        });
      } catch (e) {}
    }
  };

  $('div[id^="figureModal"]').on("show.bs.modal", function(e) {
    $(document).ajaxComplete(function(event, xhr, settings) {
      try {
        window.crs.init();
        const modal = $(e.relatedTarget).attr("data-target");
        setup(modal);
      } catch (e) {}
    });
  });

  setup();
});
